import { User, Building2, X } from 'lucide-react';
import type { ContractType } from '../_shared/types';
import { useModalKeys } from '../../../hooks/useModalKeys';

/**
 * ContractTypeModal — escolha entre PF e PJ ao iniciar novo contrato.
 * Porte do apps/prospect-web/src/components/ContractTypeModal.tsx.
 */
interface Props {
  open: boolean;
  onClose: () => void;
  onSelect: (type: ContractType) => void;
}

export default function ContractTypeModal({ open, onClose, onSelect }: Props) {
  // Esc fecha; clique fora NÃO fecha (Fase 30)
  useModalKeys(onClose, undefined, open);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-surface rounded-2xl border border-line w-full max-w-sm p-5">
        <div className="flex items-center justify-between mb-1">
          <h2 className="font-bold text-fg text-lg">Tipo de contrato</h2>
          <button onClick={onClose} className="text-fg-2 hover:text-fg">
            <X size={18} />
          </button>
        </div>
        <p className="text-sm text-fg-2 mb-5">Selecione o tipo de pessoa do cliente</p>

        <div className="space-y-2.5">
          <button
            onClick={() => onSelect('F')}
            className="w-full bg-primary-solid hover:bg-primary-solid-hover rounded-2xl p-4 flex flex-col items-center transition"
          >
            <User size={24} className="text-white mb-1" />
            <span className="text-white font-bold">Pessoa Física</span>
            <span className="text-xs text-primary">CPF</span>
          </button>
          <button
            onClick={() => onSelect('J')}
            className="w-full bg-info-solid hover:bg-info-solid-hover rounded-2xl p-4 flex flex-col items-center transition"
          >
            <Building2 size={24} className="text-white mb-1" />
            <span className="text-white font-bold">Pessoa Jurídica</span>
            <span className="text-xs text-info">CNPJ</span>
          </button>
        </div>

        <button
          onClick={onClose}
          className="w-full mt-4 py-2 text-fg-2 hover:text-fg text-sm"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
